import ChatbotModel from '@mm/state/model/ChatbotModel';

export const CHAT_WIDGET_CHANNEL_DESCRIPTIONS: Record<
  ChatbotModel['chatWidgetChannel'],
  string
> = {
  facebook: 'Facebook Messenger widget enabled',
  web_chat: 'Customers.ai webchat enabled',
  omnichat: 'Customers.ai OmniChat enabled',
};
